var map = {
	"./american_football.png": 494,
	"./badminton.png": 495,
	"./baseball.png": 496,
	"./basketball.png": 497,
	"./bowls.png": 498,
	"./boxing.png": 499,
	"./counter_strike.png": 500,
	"./cricket.png": 501,
	"./cycling.png": 502,
	"./darts.png": 503,
	"./dota_2.png": 504,
	"./e_cricket.png": 505,
	"./e_fighting.png": 506,
	"./fifa.png": 507,
	"./fifa_volta.png": 508,
	"./formula1.png": 509,
	"./golf.png": 510,
	"./handball.png": 511,
	"./ice_hokey.png": 512,
	"./motorcycle_racing.png": 513,
	"./nba2k19.png": 514,
	"./rugby.png": 515,
	"./snooker.png": 516,
	"./soccer.png": 517,
	"./tabletennis.png": 518,
	"./tennis.png": 519,
	"./volleyball.png": 520,
	"./waterpolo.png": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1261;